<template>
  <div v-if="open" class="overlay" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-head">
        <div>
          <div class="eyebrow">Colaboración</div>
          <h3>Grupos</h3>
        </div>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>

      <div v-if="limitMessage" class="limit-box">{{ limitMessage }}</div>

      <form class="inline-form" @submit.prevent="createGroup">
        <input v-model.trim="groupName" type="text" placeholder="Nombre del grupo" required>
        <button>Crear</button>
      </form>

      <div class="group-list">
        <div v-for="group in groups" :key="group.id" class="group-card">
          <div class="group-main">
            <div class="group-head">
              <div>
                <div class="group-title-row">
                  <span class="group-color" :style="{ backgroundColor: group.color || '#AFCBFF' }"></span>
                  <div class="group-name">{{ group.name }}</div>
                </div>
                <div class="group-meta">
                  {{ group.is_owner ? 'Propietario' : (group.my_role || 'miembro') }} · {{ group.member_count || group.members?.length || 0 }} integrantes
                </div>
              </div>
            </div>

            <div v-if="group.members?.length" class="member-list">
              <div v-for="member in group.members" :key="`${group.id}-${member.user_id}`" class="member-pill">
                <strong>{{ member.name }}</strong>
                <span>@{{ member.username || 'usuario' }} · {{ member.role }}</span>
              </div>
            </div>

            <div v-if="group.is_owner && availableDelegates(group).length" class="delegate-box">
              <select v-model="delegateByGroup[group.id]">
                <option value="">Delegar grupo a…</option>
                <option v-for="member in availableDelegates(group)" :key="`${group.id}-${member.user_id}`" :value="String(member.user_id)">
                  {{ member.name }} (@{{ member.username || 'usuario' }})
                </option>
              </select>
              <button class="secondary-btn" type="button" @click="emitDelegate(group)">Delegar y salir</button>
            </div>
          </div>

          <div class="group-actions">
            <button class="invite-btn" type="button" @click="$emit('invite', group)">Invitar</button>
            <button v-if="group.is_owner" class="danger-btn" type="button" @click="$emit('delete-group', group)">Eliminar</button>
            <button v-else class="secondary-btn" type="button" @click="$emit('leave-group', group)">Salir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupManagerModal',
  props: {
    open: { type: Boolean, default: false },
    groups: { type: Array, default: () => [] },
    limitMessage: { type: String, default: '' },
  },
  emits: ['close', 'create-group', 'invite', 'leave-group', 'delete-group', 'delegate-group'],
  data() {
    return {
      groupName: '',
      delegateByGroup: {},
    };
  },
  methods: {
    availableDelegates(group) {
      return (group.members || []).filter((member) => member.role !== 'owner');
    },
    async createGroup() {
      if (!this.groupName) return;
      await this.$emit('create-group', {
        name: this.groupName,
        color: '#7C9DE8',
      });
      this.groupName = '';
    },
    emitDelegate(group) {
      const delegateToUserId = Number(this.delegateByGroup[group.id] || 0);
      if (!delegateToUserId) return;
      this.$emit('delegate-group', { group, delegateToUserId });
      this.delegateByGroup = {
        ...this.delegateByGroup,
        [group.id]: '',
      };
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.34);
  display: grid;
  place-items: center;
  padding: 24px;
  z-index: 40;
}
.modal {
  width: min(760px, 100%);
  max-height: min(86vh, 920px);
  overflow: auto;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 24px;
  padding: 22px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
}
.modal-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.eyebrow {
  font-size: 12px;
  text-transform: uppercase;
  color: #64748b;
}
h3 {
  margin: 6px 0 0;
  font-size: 28px;
  color: #0f172a;
}
.close-btn {
  border: none;
  background: transparent;
  font-size: 34px;
  cursor: pointer;
}
.limit-box {
  margin-top: 18px;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(254, 242, 242, 0.96);
  border: 1px solid rgba(248, 113, 113, 0.18);
  color: #991b1b;
  line-height: 1.5;
}
.inline-form {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
}
.inline-form input,
.delegate-box select {
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.24);
  background: rgba(248,250,252,0.92);
  padding: 14px 16px;
  font-size: 16px;
  min-width: 0;
}
.inline-form button,
.invite-btn,
.secondary-btn,
.danger-btn {
  border: none;
  border-radius: 14px;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 700;
}
.inline-form button,
.invite-btn {
  background: #111827;
  color: white;
}
.secondary-btn {
  background: rgba(241, 245, 249, 0.96);
  color: #334155;
}
.danger-btn {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
}
.group-list {
  display: grid;
  gap: 12px;
  margin-top: 18px;
}
.group-card {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  border-radius: 18px;
  background: rgba(248,250,252,0.92);
  border: 1px solid rgba(148, 163, 184, 0.18);
  padding: 16px;
}
.group-main {
  display: grid;
  gap: 12px;
}
.group-title-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.group-color {
  width: 12px;
  height: 12px;
  border-radius: 999px;
}
.group-name {
  font-weight: 800;
  color: #0f172a;
}
.group-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
  text-transform: capitalize;
}
.member-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.member-pill {
  display: grid;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255,255,255,0.92);
  border: 1px solid rgba(148, 163, 184, 0.18);
}
.member-pill strong {
  color: #0f172a;
  font-size: 13px;
}
.member-pill span {
  color: #64748b;
  font-size: 12px;
}
.delegate-box {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
}
.group-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-self: start;
}
@media (max-width: 720px) {
  .group-card {
    grid-template-columns: 1fr;
  }
  .group-actions,
  .delegate-box,
  .inline-form {
    grid-template-columns: 1fr;
    display: grid;
  }
}
</style>
